"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLoggerContext = exports.LoggerContextProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const frontend_infra_logger_1 = require("@forto-dev/frontend-infra-logger");
const react_1 = require("react");
const ConfigContext_1 = require("./ConfigContext");
const LoggerContext = (0, react_1.createContext)({});
const useLogger = () => {
    const { APP_ENV, LOG_LEVEL } = (0, ConfigContext_1.useConfigContext)();
    return (0, frontend_infra_logger_1.initLogger)({
        logLevel: LOG_LEVEL || APP_ENV === 'production' ? 'info' : 'debug',
        enableExternalCapture: true,
    });
};
const LoggerContextProvider = ({ children }) => {
    return (0, jsx_runtime_1.jsx)(LoggerContext.Provider, { value: useLogger(), children: children });
};
exports.LoggerContextProvider = LoggerContextProvider;
const useLoggerContext = () => {
    const context = (0, react_1.useContext)(LoggerContext);
    if (!context) {
        throw new Error('useLoggerContext must be used within a LoggerContextProvider');
    }
    return context;
};
exports.useLoggerContext = useLoggerContext;
//# sourceMappingURL=LoggerContext.js.map